import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  balanceMinor: { color: theme.COLOR_TEXT_TERTIARY, fontSize: rf(28), lineHeight: rh(34), paddingTop: rh(2) },
  balance: { fontSize: rf(48), lineHeight: rh(52.8), textAlign: 'center', letterSpacing: rw(-1.44) },
}))
